import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { pageSelected } from "../../features/filter/filterSlice";

const Pagination = () => {
  const dispatch = useDispatch();
  const { lastPage } = useSelector((state) => state.videos);
  const { page } = useSelector((state) => state.filter);

  // const [currentPage, SetCurrentPage] = useState(page); //not reseting when filter reset

  const paginationElement = [];
  for (let i = 1; i <= lastPage; i++) {
    paginationElement.push(
      <div
        key={i}
        onClick={() => handlePageSelect(i)}
        className={`${i === page ? "bg-blue-600" : "bg-blue-400"} text-white px-4 py-1 rounded-full cursor-pointer`}
      >
        {i}
      </div>
    );
  }
  // render if current page change
  useEffect(() => {
    dispatch(pageSelected(page));
  }, [page, dispatch]);

  const handlePageSelect = (pageNumber) => {
    dispatch(pageSelected(pageNumber));
  };
  return (
    lastPage > 1 && (
      <section className='pt-12'>
        <div className='max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end'>{paginationElement}</div>
      </section>
    )
  );
};

export default Pagination;
